<!-- <div class="container-fluid">-->
  <div class="row">
    <div class="col-10">
      <div class="page-title-box d-flex align-items-center justify-content-between">
        <h4 class="mb-0">Design Master</h4>
      </div>
    </div>
    <div class="col-2">
    </div>
  </div>
<br>

   <form class="needs-validation" (ngSubmit)="validSubmit()" [formGroup]="validationform">

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">

            <div class="row">

            </div>
            <div class="row">

              <div class="col-md-3">
                <div class="form-group">

                  <label for="BrandName">Brand</label>
                  <input class="form-control" formControlName="BrandName" id="BrandName"
                     [ngClass]="{'is-invalid': submit && form.BrandName.errors}">
                  <div *ngIf="submit && form.BrandName.errors" class="invalid-feedback">
                    Please provide Brand
                  </div>
                </div>
              </div>

              <div class="col-md-3">
                <div class="form-group">
                  <label for="StyleNo">Style No</label>
                  <input class="form-control" formControlName="StyleNo" id="StyleNo"
                     [ngClass]="{'is-invalid': submit && form.StyleNo.errors}">
                  <div *ngIf="submit && form.StyleNo.errors" class="invalid-feedback">
                    Please provide Style
                  </div>
                </div>
              </div>

              <div class="col-md-2">
                <div class="form-group">
                  <label for="Gauge">Gauge</label>
                  <input class="form-control" formControlName="Gauge" id="Gauge"
                     [ngClass]="{'is-invalid': submit && form.Gauge.errors}">
                  <div *ngIf="submit && form.Gauge.errors" class="invalid-feedback">
                    Please provide Gauge
                  </div>
                </div>
              </div>

              <div class="col-md-2">
                <div class="form-group">
                  <label for="Timing">Timing</label>
                  <input class="form-control" formControlName="Timing" id="Timing"
                     [ngClass]="{'is-invalid': submit && form.Timing.errors}">
                  <div *ngIf="submit && form.Timing.errors" class="invalid-feedback">
                    Please provide Timing
                  </div>
                </div>
              </div>


              <div class="col-md-2">
                <div class="form-group">
                  <label for="SampleType">Sample Type</label>
                  <input class="form-control" formControlName="SampleType" id="SampleType"
                     [ngClass]="{'is-invalid': submit && form.SampleType.errors}">
                  <div *ngIf="submit && form.SampleType.errors" class="invalid-feedback">
                    Please provide Sample Size
                  </div>
                </div>
              </div>

              <div class="col-md-2">
                <div class="form-group">
                  <label for="SampleSize">Sample Size</label>
                  <input class="form-control" formControlName="SampleSize" id="SampleSize"
                     [ngClass]="{'is-invalid': submit && form.SampleSize.errors}">
                  <div *ngIf="submit && form.SampleSize.errors" class="invalid-feedback">
                    Please provide Sample Size
                  </div>
                </div>
              </div>

            </div>



          </div>
        </div>
        <!-- end card -->
      </div> <!-- end col -->


    </div>
   </form>
    <div class="row" >
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body" >
            <h4 class="card-title">Consumption Detail</h4>
            <div>
              <div class="table-responsive"  style="overflow-x:scroll;">

                  <table class="table">

                    <thead>
                      <tr class="TableHeaderRow">
                        <th>#</th>
                        <th style="min-width:250px!important">Colour Name</th>
                        <th style="min-width:200px!important">Count</th>
                        <th style="min-width:100px!important">Content</th>
                        <th style="min-width:100px!important">Lot No</th>
                        <th style="min-width:120px!important">Cons(Kgs)/Wt</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let item of VoucherDetailList;let i=index">
                        <td>{{i+1}}</td>
                        <td   style="min-width:200px!important">
                          <input class="form-control" id="ColourName + {{item.id}}" value=""
                        (change)="checkLastRow(i)"   [(ngModel)]="item.ColourName"></td>
                        <td   style="min-width:200px!important">
                            <input class="form-control" id="CountDesc + {{item.id}}" value=""
                            [(ngModel)]="item.CountDesc"></td>
                            <td   style="min-width:200px!important">
                              <input class="form-control" id="Content + {{item.id}}" value=""
                              [(ngModel)]="item.Content"></td>

                              <td   style="min-width:200px!important">
                                <input class="form-control" id="LotNo + {{item.id}}" value=""
                                [(ngModel)]="item.LotNo"></td>

                                <td  >
                              <input type="number" style="text-align:right ;" class="form-control" id="ConsQty + {{item.id}}" value="0"
                            (change)="calculateProductAmount($event,item)"   [(ngModel)]="item.ConsQty"></td>



                          <td   style="width:100px!important">
                          <button type="button" class="mdi mdi-18px mdi-delete text-danger"
                            (click)="DeletePrdItem(item,i)"></button>
                        </td>
                      </tr>

                      <tr class="TotalRow">
                        <td></td>
                        <td>Total</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td style="text-align:right ;padding-right: 30px;">{{TotalItemQty}}</td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    </tbody>
                  </table>

              </div>
            </div>


          </div>
        </div>
      </div>
    </div>





    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">

              <div class="col-md-4">
                <div class="form-group">
                       <label for="TypeTrackingNumber">Upload File(Front)</label>
                       <input type="file" name="fileExcel" class="form-control"
                               (change)="uploadExcel($event,addmstModal)" #fileUploadInput />
                       <img  class="images" [src]="fileBase64" height="200px" width="200px" />
                             </div>

              </div>
              <div class="col-md-4">
                <div class="form-group">

                      <label for="TypeTrackingNumber">Upload File(Back)</label>
                      <input type="file" name="fileExcelBack" class="form-control"
                              (change)="uploadExcelBack($event,addmstModal)" #fileUploadInputBack />
                      <img  class="images" [src]="fileBase64Back" height="200px" width="200px" />



              </div>
            </div>
                <div class="col-lg-2">
                </div>
                  <div class="col-lg-2">
                  <br>
                  <div class="card">
                    <button class="btn btn-primary " (click)="validSubmit()">Save</button>
                </div>
              </div>


            </div>
            </div>



        </div>
        <!-- end card -->
      </div> <!-- end col -->



    <!-- Modal -->
    <ng-template #addmstModal let-modal>
      <div class="modal-header">
        <h5 class="modal-title mt-0">Rate List Upload</h5>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-hidden="true">×</button>
      </div>
      <div class="modal-body">
        <form class="needs-validation" (ngSubmit)="validSubmit()" [formGroup]="validationform">
          <div class="row">
            <div class="col-lg-12">
              <div class="card o">
                <div class="card-body o">
                  <div class="row">
                    <div class="col-md-8">
                      <div class="form-group">
                        <label for="Remarks">Remarks</label>
                        <textarea class="form-control" formControlName="Remarks" id="Remarks"
                          [ngClass]="{'is-invalid': submit && form.Remarks.errors}">
                        </textarea>
                        <div *ngIf="submit && form.Remarks.errors" class="invalid-feedback">
                          Please provide Remarks
                        </div>
                      </div>
                    </div>


                  </div>




                <div class="row">
                  <div class="col-md-7">
                  </div>
                  <div class="col-md-5">
                    <button type="submit" class="btn btn-primary tblebtn w-md">
                      Save
                    </button>&nbsp;
                    <button type="button" (click)="modal.dismiss('Cross click')" class="btn btn-secondary tblebtn w-md">
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </form>
      </div>
    </ng-template>
    </div>
